import { Carousel } from "@mantine/carousel"
import '@mantine/carousel/styles.css'
import { Box, Card, Flex, rem, Title } from "@mantine/core"
import ModelCard from "components/models/list/card"
import ModelCardSkeleton from "components/models/list/card/skeleton"
import { useGetModelsInfinity } from "hooks/useRequest/models/models"
import { FC } from "react"
import IModelLabels from "rules/interface/models/model-labels.interface"
import { IModels } from "rules/interface/models/models.interface"



interface IProps {
    labels: IModelLabels
}

const ModelSimilar: FC<IProps> = ({ labels }) => {

    const { data, isLoading, isError, isFetching, isSuccess, hasNextPage, fetchNextPage } = useGetModelsInfinity({
        filters: {
            // labels: {
            //     color: []
            // }
        },
        params: {
            limit: 9,
            sort: "most-popular"
        },
    })

    const loadingSkeleton = () => {
        return Array.from({ length: 9 }, (v, i) => (
            <Carousel.Slide key={i}><ModelCardSkeleton key={i} /></Carousel.Slide>
        ))
    }

    if (!(isSuccess && data.pages.flatMap(item => item.data.data)?.length > 0)) {
        return <></>
    }


    return (
        <Box c="white" py={40} bg="#F9F9F9">
            <Flex className="container" direction="column" gap={{ base: 16, sm: 24 }} py={{ base: 24, sm: 48 }}>
                <Flex align="center" gap="md">
                    <Card radius="xl" bg="blue" p={0} w={rem(16)} h={rem(16)} />
                    <Title order={4} fw={700} fz={{ base: rem(18), sm: rem(24) }} lh={{ base: rem(36), sm: rem(64) }} c="black">
                        نـمونه‌های مشابـه
                    </Title>
                </Flex>

                {
                    isError ? <p>در دریافت اطلاعات مشکلی بوجود آمده است</p>
                        :
                        <Carousel
                            slideSize={{ base: "100%", sm: "50%", md: "33.333333%" }}
                            slideGap="md"
                            align="start"
                            slidesToScroll={1}
                            controlsOffset={-100}
                        >
                            {
                                isLoading ? loadingSkeleton() : isSuccess &&
                                    data.pages?.map(page =>
                                        page?.data?.data?.map((item: IModels) =>
                                            <Carousel.Slide key={item._id}>
                                                <ModelCard whitinTitle whitinButton data={item} />
                                            </Carousel.Slide>
                                        )
                                    )
                            }
                            {
                                isFetching && loadingSkeleton()
                            }
                        </Carousel>
                }

                {/* {hasNextPage &&
                    <Button
                        rightSection={<ArrowLeftIcon size={12} />}
                        w={{ sm: "fit-content" }}
                        mx={{ sm: "auto" }}
                        onClick={() => fetchNextPage()}
                        loading={isFetching}
                    >
                        نمایش بیشتر
                    </Button>
                } */}
            </Flex>
        </Box>
    )
}

export default ModelSimilar